import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import PropTypes from "prop-types";
import RoomRates from "../components/Views/RoomRates.jsx";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";

class RoomRatesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("room_rates");
        this.state = {
            ...this.state,
            loadAfterChangedByRule: false,
            loading: true,
        };
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    switchloadAfterChangeByRule = () =>
        this.setState((prevState) => ({
            loadAfterChangedByRule: !prevState.loadAfterChangedByRule,
        }));

    startLoading = () =>
        this.setState((state) => ({ ...state, loading: true }));

    render = () => {
        const routes = this.datasource.routes();
        const auxDataRoomTypes =
            this.props.auxData && this.props.auxData.room_types;
        const auxDataRates =
            this.props.auxData && this.props.auxData.rates_short;
        const pathToEditByParams =
            this.datasource.dataPath + "/" + this.datasource.modelName + "/";

        let roomRates = (
            <Box mt={4}>
                <LinearProgress mt={3} />
            </Box>
        );

        if (auxDataRoomTypes && auxDataRates) {
            if (auxDataRates.length < 1 && auxDataRoomTypes.length < 1) {
                roomRates = (
                    <Typography>
                        Отсутствуют данные по категориям номеров и тарифам
                    </Typography>
                );
            } else if (auxDataRates.length < 1 && auxDataRoomTypes.length > 0) {
                roomRates = (
                    <Typography>Отсутствуют данные по тарифам</Typography>
                );
            } else if (auxDataRates.length > 0 && auxDataRoomTypes.length < 1) {
                roomRates = (
                    <Typography>
                        Отсутствуют данные по категориям номеров
                    </Typography>
                );
            } else if (auxDataRates.length > 0 && auxDataRoomTypes.length > 0) {
                roomRates = (
                    <Route path={routes.home} exact>
                        <RoomRates
                            auxData={{
                                room_types: auxDataRoomTypes,
                                rates: auxDataRates,
                            }}
                            initAction={this.getAllItems}
                            items={this.state.AllItems}
                            objectTemplate={this.datasource.getEmptyObject()}
                            submitAction={this.updateAllItems}
                            errorFields={this.state.error}
                            updateAction={this.setItems}
                            pathToEditByParams={pathToEditByParams}
                            loading={this.state.loadAfterChangedByRule}
                            loadingCustom={this.state.loading}
                            switchloadAfterChangeByRule={
                                this.switchloadAfterChangeByRule
                            }
                            startLoading={this.startLoading}
                            hotelId={this.props.match.params.mainId}
                        />
                    </Route>
                );
            }
        }

        return (
            <Paper elevation={3}>
                <Box p={3}>
                    <Typography mb={3} variant={"h5"}>
                        Стоимость проживания
                    </Typography>
                </Box>
                <div style={{ height: "45px" }}></div>
                {roomRates}
            </Paper>
        );
    };
}

RoomRatesContainer.propTypes = {
    auxEntity: PropTypes.array.isRequired,
    auxSource: PropTypes.func.isRequired,
    auxData: PropTypes.object.isRequired,
};

export default RoomRatesContainer;
